export const expiryMilliseconds = 1000 * 60 * 5;
export const username2IdStaleTime = 14 * 24 * 60 * 60 * 1000;
export const userStaleTime = 10 * 60 * 1000;
